import React from 'react';
import styled from 'styled-components';

export const StepPageWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}));
